import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  alert: {
    marginBottom: 16,
  },
  knowMoreLink: {
    whiteSpace: 'nowrap',
    color: theme.palette.error.main,
    textDecoration: 'underline',
  },
  actionBtn: {
    whiteSpace: 'nowrap',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
    padding: '.5rem 1rem',
    '&:hover': {
      opacity: '.9',
    },
  },
}));
